import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Button,Modal } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { taskmanagementschema } from "../../../../JsonData/CreateTaskConfig";
import FormHandler from "../../Common/Form/FormHandler/FormHandler";
import { TaskFormConfig } from "../../../../JsonData/CreateTaskConfig";
import { useTranslation } from "react-i18next";

import {
  getData,
  postDataWithBody,
  putDataWithBody,
} from "../../../../Services/Services";
import {
  getTaskConfigsURL,
  getAllActiveRole,
  createTaskURL,
  findTaskById,
  getTaskListURL,
  updateTaskURL,
} from "../../../../Services/EndPoints";
import Loader from "react-spinner-loader";
import { downloadFile } from "../../../../Components/UiComponents/utils";
import { PaperClipIcon } from "../../../../Components/IconComponents";
import { toast } from "react-toastify";
//Task Management

const CreateTaskForm = (props) => {
  const [CreateTaskConfig, setCreateTaskConfig] = useState(TaskFormConfig);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const [taskConfigs, setTaskConfigs] = useState([]);
  const [setViewTask, setViewTaskById] = useState(null);
  const [roleArr, setRoleArr] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const { state } = useLocation();
  let id = state?.data.id;
    const edit = state?.edit;
  let mediapath = state?.data.media_file_path;
  const [fileObjs, setFileObjs] = useState([]);

  let downloadAttachmentURL =
    process.env.REACT_APP_APP_SERVER_ADDRESS +
    "/" +
    process.env.REACT_APP_CORE_CONTEXT_PATH_NAME +
    "/download/download_attachments/?directoryPath=" +
    mediapath +
    "&fileName=Tasks.zip";

  const {
    register,
    handleSubmit,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(taskmanagementschema[activeTab]),
    mode: "all",
  });

  useEffect(() => {
    getInitData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // GET
  async function getViewData() {
    var getViewData = await getData(getTaskListURL);
    // setViewTask(getViewData);
    if (id) {
      await populateViewFormFrEdit(id);
    }
  }

  //EDIT
  async function populateViewFormFrEdit(id) {
    var viewData = await postDataWithBody(findTaskById, [id], {});
    viewData = viewData[0];
    setViewTaskById(viewData);
    reset(viewData);
  }

  const GenerateForm = (fields, register, errors, control) => {
    return (
      <div>
        {taskConfigs.length > 0 && roleArr.length > 1 && (
          <FormHandler
            register={register}
            errors={errors}
            fields={fields}
            control={control}
            editId={id}
            columns={2}
            getValues={getValues}
            fileObjs={fileObjs}
            setFileObjs={setFileObjs}
          />
        )}
      </div>
    );
  };

  const generateTabsData = (tabWiseData) => {
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    return tabWiseData;
  };

  const submitHandler = async (data, e) => {
    setLoader(true);
    setIsSubmitting(true); // Disable the button
    e.preventDefault();
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (key === "task_media_file") {
        // Handling file uploads correctly
        if (value && value.length > 0) {
          value.forEach((file) => formData.append(key, file));
        }
      } else if (key === "roleEntity") {
        // Skip appending `roleEntity` if it's an object (remove it from formData)
        // Alternatively, you could append specific properties if needed
        // Example: formData.append('roleEntityName', value.name);
        return;
      } else {
        formData.append(key, value);
      }
    });

    // Always append 'status' payload
    formData.append("status", true);

    let res;
    const headers = { "Content-Type": "multipart/form-data" };
    if (id) {
      formData.append("id", id);
      res = await putDataWithBody(updateTaskURL, formData, headers);
    } else {
      res = await postDataWithBody(createTaskURL, formData, headers);
    }

    if (res.status === "success") {
      toast.success(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
      navigate("/sop-management/view-task");
    } else {
      toast.error(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
    }
    setIsSubmitting(false); // Re-enable the button
    setLoader(false);
  };


  const handleConfirmCancel = () => {
    // Basic form reset
    reset({});
    
    // Clear fileObjs state
    setFileObjs([]);
    
    // Force re-render the form by changing the key
    setFormKey(prevKey => prevKey + 1);
    
    // Close the modal
    setShowCancelModal(false);
  };



  async function getInitData() {
    setLoader(true);
    await getTaskConfigs();
    await fetchAllRoles();
    // await getTaskStatus();
    await getViewData();
    setLoader(false);
    if (id) {
      populateViewFormFrEdit(id);
    }
  }
  async function fetchAllRoles() {
    let rolearr = await getData(getAllActiveRole);
    setRoleArr(rolearr);
    let roleFrDropdown = [];
    for (let role in rolearr) {
      roleFrDropdown.push({
        label: rolearr[role].name,
        value: rolearr[role].id,
      });
    }
    CreateTaskConfig[0].fields[2]["options"] = roleFrDropdown;
    setCreateTaskConfig(CreateTaskConfig);
  }
  async function getTaskConfigs() {
    let res = await postDataWithBody(
      getTaskConfigsURL,
      ["TSK_PRIOR", "INCDNT_CAT", "TSK_STAT", "TSK_TYP"],
      {}
    );
    setTaskConfigs(res);
    let config_type = {};
    for (let config in res) {
      if (config_type[res[config].category_name]) {
        config_type[res[config].category_name].push({
          label: res[config].value,
          value: res[config].id,
        });
      } else {
        config_type[res[config].category_name] = [
          { label: res[config].value, value: res[config].id },
        ];
      }
    }
    //alert(config_type["INCDNT_CAT"])
    CreateTaskConfig[0].fields[0]["options"] = config_type["INCDNT_CAT"];
    CreateTaskConfig[0].fields[2]["options"] = config_type["TSK_PRIOR"];
    CreateTaskConfig[0].fields[3]["options"] = config_type["TSK_STAT"];
    CreateTaskConfig[0].fields[3]["options"] = config_type["TSK_TYP"];
    setCreateTaskConfig(CreateTaskConfig);
  }
  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  const tabsData = generateTabsData(CreateTaskConfig);

  return (
    <div className="mt-4">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />

      <div className="form-body">
        <div className="registration__form--body">
          <form key={formKey} onSubmit={handleSubmit(submitHandler)} name="CreateTaskRegForm">
            <div>
              {tabsData?.map((tab) => (
                <>
                  {tab.id === activeTab && (
                    <>
                      <div>{tab.component}</div>
                    </>
                  )}
                </>
              ))}
            </div>

            <div>
              {id && mediapath ? (
                <span className="multi_file_uploaded cursor-pointer ">
                  <div
                    onClick={() =>
                      downloadFile(
                        downloadAttachmentURL,
                        "Tasks" + new Date().getTime() + ".zip"
                      )
                    }
                  >
                    <PaperClipIcon className="cursor-pointer" /> Attached files
                  </div>
                </span>
              ) : (
                ""
              )}
            </div>

            <div className="d-flex justify-content-center">
              {tabsData.length - 1 === activeTab && (
                <>
                  <Button
                    type="submit"
                    className="mx-2"
                    variant="primary"
                    disabled={isSubmitting} // Disable when submitting
                  >
                    {edit? t("Update") : t("saveAndSubmit")}
                  </Button>
                  {!edit && <Button
                    type="button"
                    variant="primary"
                    className="mx-2"
                    onClick={handleCancelClick}
                    // Disable cancel button when form is submitting
                  >
                    Cancel
                  </Button>}
                </>
              )}
            </div>
          </form>
        </div>
      </div>
        <Modal
              show={showCancelModal}
              onHide={() => setShowCancelModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Would you like to clear the input values?
              </Modal.Body>
              <Modal.Footer>
                <button className="btn" style={{
                  backgroundColor: 'lightgray',
                  color: '#000',
                  marginRight: '10px'
                }} onClick={() => setShowCancelModal(false)}>
                  No
                </button>
                <button className="btn" style={{
                  backgroundColor: 'green',
                  color: '#fff'
                }} onClick={handleConfirmCancel}>
                  Yes
                </button>
              </Modal.Footer>
            </Modal>
    </div>
  );
};
export default CreateTaskForm;
